module.exports = __webpack_public_path__ + "img/nobleriding_option_02.613c134b.jpg";